var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.3333 18.0833C41.3333 15.6809 41.3333 14.4797 41.0692 13.4942C40.3526 10.8197 38.2636 8.7307 35.5891 8.01407C34.6036 7.75 33.4024 7.75 31 7.75C28.5975 7.75 27.3963 7.75 26.4108 8.01407C23.7363 8.7307 21.6473 10.8197 20.9307 13.4942C20.6666 14.4797 20.6666 15.6809 20.6666 18.0833M13.4333 54.25H48.5666C51.4602 54.25 52.907 54.25 54.0122 53.6869C54.9844 53.1915 55.7748 52.4011 56.2702 51.429C56.8333 50.3237 56.8333 48.8769 56.8333 45.9833V26.35C56.8333 23.4564 56.8333 22.0096 56.2702 20.9044C55.7748 19.9322 54.9844 19.1418 54.0122 18.6465C52.907 18.0833 51.4602 18.0833 48.5666 18.0833H13.4333C10.5397 18.0833 9.09289 18.0833 7.98768 18.6465C7.0155 19.1418 6.2251 19.9322 5.72976 20.9044C5.16663 22.0096 5.16663 23.4564 5.16663 26.35V45.9833C5.16663 48.8769 5.16663 50.3237 5.72976 51.429C6.2251 52.4011 7.0155 53.1915 7.98768 53.6869C9.09289 54.25 10.5397 54.25 13.4333 54.25Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/icon1.89d59f08c4704b5ec8d815d48350c534.svg";
export { ForwardRef as ReactComponent };